/** @format */

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchNotifications,
  selectNotifications,
  selectActiveFilter,
  setActiveFilter,
} from "../../../components/common/Store/notificationsSlice";

import NotificationItem from "./NotificationItem";

const Notifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(selectNotifications);
  const activeFilter = useSelector(selectActiveFilter);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  const handleFilterChange = (filter) => {
    dispatch(setActiveFilter(filter));
  };

  const unreadNotifications = notifications.filter(
    (notification) => !notification.notification_read
  );

  const filteredNotifications =
    activeFilter === "unread" ? unreadNotifications : notifications;

  return (
    <div className="notifications border-l p-3">
      <div className="notifications-header flex items-center justify-between mb-2">
        <h2 className="text-lg">Notifications</h2>
        <button
          className="text-blue-500 hover:text-blue-700 text-xs"
          onClick={() => handleFilterChange("all")}
        >
          View All
        </button>
      </div>
      <div className="notifications-tab-container overflow-x-scroll">
        <div className="border-gray-200">
          <ul
            className="flex -mb-px text-sm font-medium text-center"
            id="myTab"
            data-tabs-toggle="#myTabContent"
            role="tablist"
          >
            <li className="mr-2" role="presentation">
              <button
                className={`inline-block p-3 border-b-2 ${
                  activeFilter === "all"
                    ? "border-black text-black"
                    : "border-transparent text-dark"
                } hover:text-black`}
                id="all-tab"
                data-tabs-target="#all-content"
                type="button"
                role="tab"
                aria-controls="all-content"
                aria-selected={activeFilter === "all"}
                onClick={() => handleFilterChange("all")}
              >
                All Notifs ({notifications.length})
              </button>
            </li>
            <li className="mr-2" role="presentation">
              <button
                className={`inline-block p-3 border-b-2 ${
                  activeFilter === "unread"
                    ? "border-black text-black"
                    : "border-transparent text-gray-300"
                } hover:text-black`}
                id="unread-tab"
                data-tabs-target="#unread-content"
                type="button"
                role="tab"
                aria-controls="unread-content"
                aria-selected={activeFilter === "unread"}
                onClick={() => handleFilterChange("unread")}
              >
                Unread ({unreadNotifications.length})
              </button>
            </li>
          </ul>
        </div>
        <div id="myTabContent">
          <div
            className="hidden p-4 rounded-lg text-dark"
            id="all-content"
            role="tabpanel"
            aria-labelledby="all-tab"
          >
            {filteredNotifications.map((notification) => (
              <NotificationItem
                key={notification.notification_id}
                notification={notification}
              />
            ))}
          </div>
          <div
            className="hidden p-4 rounded-lg text-dark"
            id="unread-content"
            role="tabpanel"
            aria-labelledby="unread-tab"
          >
            {filteredNotifications.map((notification) => (
              <NotificationItem
                key={notification.notification_id}
                notification={notification}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
